import styled from 'styled-components'
import theme from '../../../theme'

export const ScreenWrapper = styled.section`
  background-color: ${theme.colors.background.color};
  min-height: 100vh;
  width: 100%;
  display: flex;
  // flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
`
export const SummaryDataWrapper =styled.div`
  grid-column: span 8;
  display: flex;
  gap:1rem;
  align-items: center;
  @media (max-width: 768px) {
    width: 100%;
    flex-direction:column;
  }
`
export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(8, auto);
  grid-gap: 1rem;
  background-color: ${theme.colors.background.color};
  min-height: 100%;
  padding: 1rem;
  width: 100%;
  @media(max-width:768px){
    display:flex;
    flex-direction:row;
    flex-wrap:wrap;
  }
`

export const Title = styled.div`
  grid-column: span 8;
  display: flex;
  align-items: center;
   @media(max-width:768px){
    width:100%;
  }
`
export const DataLeftStyled = styled.div`
  grid-column: span 4;
  
  @media(max-width: 768px){
    width:100%;
  }
`
export const Card = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 300px;
  height: 125px;
  background: white;
  padding: 1.5rem;
  border-radius: 20px;
  box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8);
  margin-bottom: 1rem;
  @media(max-width:768px){
    width:100%;
  }
  
`
export const Text = styled.article`
  margin-left: 10px;
  font-size: 1.25rem;
  height: 60%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding-left: 0.75rem;
`

export const CardWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  padding-top: 2rem;
  @media(max-width:768px){
    flex-direction: column;
   align-items: center;
   padding: 1rem;
  }
`
